import { type OnboardingBioAndSkillsProps } from '../../../features';
import Bio from './Edit/Bio';
import { OnboardGrid } from './Edit/Onboard.styled';
import Skills from './Edit/Skills';

export const OnboardBioAndSkills = ({ bio, skills, community }: OnboardingBioAndSkillsProps) => {
  const { initialValue, error } = bio;
  const { initialValues } = skills;
  return (
    <OnboardGrid>
      <Bio description={initialValue} error={error} />
      <Skills skills={initialValues} tagColor={community.colors.voteBar} />
    </OnboardGrid>
  );
};
